import React from 'react';
import { useReactFlow } from 'reactflow';

// Wraps a node component with an always-visible delete (×) button in the corner.
// React Flow's default deletion is the Backspace key, which doesn't exist on
// touch devices — so this makes removing a node possible on mobile and obvious
// on desktop. The wrapper tightly wraps the node (block, auto size) so it matches
// the react-flow__node box and doesn't shift Handle positions.
export default function withNodeDelete(NodeComponent) {
  function DeletableNode(props) {
    const { deleteElements } = useReactFlow();

    const handleDelete = (e) => {
      e.stopPropagation();
      e.preventDefault();
      // Removes the node and any connected edges.
      deleteElements({ nodes: [{ id: props.id }] });
    };

    return (
      <div style={{ position: 'relative' }}>
        <button
          type="button"
          className="rf-node-delete-btn nodrag nopan"
          onClick={handleDelete}
          // Stop React Flow from starting a drag/selection when the button is pressed.
          onPointerDown={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
          aria-label="Delete node"
          title="Delete node"
        >
          ×
        </button>
        <NodeComponent {...props} />
      </div>
    );
  }
  DeletableNode.displayName = `Deletable(${NodeComponent.displayName || NodeComponent.name || 'Node'})`;
  return DeletableNode;
}
